module.exports = __webpack_public_path__ + "static/media/Shop_Gold_Cap@3x.8665d105.png";